import { useMutation } from "@tanstack/react-query";
import { sendVerifyEmailToAnswerer } from "../../../api/answerer";
import { useAuth } from "../../auth/hooks/useAuth";

/**
 * 検証メール送信Hook
 */
export const useSendVerifyEmailToNewAnswerer = () => {
    const { csrfToken } = useAuth();

    return useMutation({
        mutationFn: async (answererId: string) => {
            await sendVerifyEmailToAnswerer(answererId, csrfToken);
        },
    });
};
